module.exports = __webpack_public_path__ + "img/teacher-bg2.bbef6e97.png";